module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/car-bg-l-689a3d2d87af79b668d1626c6fd9aad3.png";